import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/outlet/sales-channel/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello "/_app/outlet/sales-channel/"!</div>
}
